export const LangFr = {
    name: 'fr',
    data: {
        "sidebar": {
            'dashboard': 'Tableau de bord',
            "profil": "Mon profil",
            'search': 'Recherche de missions',
            'file': 'Mes documents',
            'mission': 'Mes missions',
            'help': 'Aide'
        },
        'profil': {
            'profil': 'Mon profil',
            'account': 'Mon compte',
            'knowledge': 'Mon savoir faire',
            'proof': 'Mes justificatifs',
            'availabilities': 'Mes disponibilités',
            'params': 'Paramètres'
        },
        'savoir': {
            "cv": 'Curriculum Vite',
            'exp': 'Expériences',
            'skills': 'Compétences',
            'lang': 'Languages',
            'tools': 'Matériels possédés'
        },
        'proof': {
            'identity': 'Justificatif d’identité',
            'degree': 'Formations',
            'licence': 'Permis'
        },
        'availabilities': {
            'myhours':'Mes horaires',
            'dispo':'Périodes d\'indisponibilité',
            'subtitleH':'Indiquez à quelles tranches horaires vous êtes disponible' +
                ' pour travailler.',
            'subtitleD':'Indiquez les périodes où vous n\'êtes pas du tout disponible.'

        },
        'justify':{
            'm_vitale_title_c':'Ajouter une carte vitale',
            'm_vitale_title_u':'Modifier la carte vitale',
            'm_vitale_title_d':'Supprimer une carte vitale',
            'm_vitale_d_content':'Êtes-vous sûr de vouloir supprimer votre carte' +
                ' vitale ? Cette action est irréversible.',
            'm_iban_title_c':'Ajouter une identité bancaire',
            'm_iban_title_u':'Modifier l\'identité bancaire',
            'm_iban_title_d':'Supprimer une identité bancaire',
            'm_identity_title_c':'Validation d’identité',
            'm_proof_title_c':'Ajouter un justificatif de domicile',
        },
        'missionCreation': {
            'steps': {
                'motif': 'Motif',
                'period': 'Période',
                'details': 'Détails',
                'invitation': 'Invitation',
                'confirmation': 'Confirmation',
            },
            'wizard': {
                'stepCount': 'Étape {current} sur {total}',
                'back': 'Retour',
                'next': 'Suivant',
                'create': 'Créer la mission',
                'creating': 'Création de la mission',
                'backToStep': 'Revenir à cette étape',
                'leaveLabel': 'Quitter la création de mission',
                'leaveTooltip': 'Quitter',
                'leaveConfirm': 'Êtes-vous sûr de vouloir quitter la page ? Vos modifications ne seront pas enregistrées.',
            },
            'motif': {
                'title': 'Motifs',
                'description': 'Sélectionnez le motif de recours à l\'intérim pour cette mission.',
                'types': {
                    'replacement': 'Remplacement d\'un ou plusieurs salariés absents',
                    'activityIncrease': 'Accroissement temporaire d\'activité',
                    'awaitingRecruitment': 'En attente de recrutement',
                    'customaryContract': 'Contrat temporaire d\'usage',
                    'seasonal': 'Emploi à caractère saisonnier',
                },
            },
            'motifForm': {
                'description': 'Votre description',
                'maxLengthHint': '250 caractères',
                'lengthError': 'Veuillez faire un message de plus de 10 caractères',
                'name': 'Nom',
                'firstname': 'Prénom',
                'replacedPosition': 'Poste remplacé',
                'absenceDescription': 'Décrivez précisément le motif de l\'absence de votre salarié.',
                'date': 'Date',
                'nameRequired': 'Veuillez indiquer un nom',
                'firstnameRequired': 'Veuillez indiquer un prénom',
                'positionRequired': 'Veuillez indiquer un poste',
                'nameMissing': 'Un nom est requis',
                'firstnameMissing': 'Un prénom est requis',
                'dateMissing': 'Une date est requise',
            },
            'scheduleForm': {
                'selectedDay': 'Jour sélectionné',
                'startTime': 'Heure de début',
                'endTime': 'Heure de fin',
                'repeatUntilEnd': 'Répéter jusqu\'à la fin de la mission',
                'repeatEndDate': 'Se termine dans',
                'deleteThisDay': 'Cette journée',
                'deleteThisDayAndNext': 'Cette journée et toutes les suivantes aux mêmes périodes',
                'deleteAllSame': 'Toutes les journées aux mêmes périodes',
                'removePeriod': 'Retirer la période',
            },
            'scheduleList': {
                'deleteWeek': 'Supprimer la semaine',
                'previousWeek': 'Semaine précédente',
                'nextWeek': 'Semaine suivante',
                'deleteDay': 'Supprimer',
                'deleteDayLabel': 'Supprimer la journée',
                'editDay': 'Modifier',
                'editDayLabel': 'Modifier la journée',
                'addDay': 'Ajouter',
                'addDayLabel': 'Ajouter une journée',
            },
            'modal': {
                'close': 'Fermer',
            },
            'salary': {
                'hourlyRate': 'Taux horaire brut',
                'placeholder': 'Ex : 12.50',
                'unit': '€/heure',
                'tooltip': 'La rémunération comprend le salaire ou traitement de base et tous les autres avantages et accessoires payés directement ou indirectement, en espèces ou en nature.',
            },
            'contact': {
                'name': 'Nom complet du responsable',
                'poste': 'Fonction',
            },
            'period': {
                'title': 'Période de la mission',
                'description': 'Indiquez les dates de début et de fin de la mission.',
                'dateStart': 'Date de début',
                'dateEnd': 'Date de fin',
                'datePlaceholder': 'Sélectionner',
                'invalidDate': 'Veuillez indiquer une date valide',
                'scheduleTitle': 'Planning',
                'scheduleDescription': 'Définissez les horaires de travail pour chaque jour de la mission.',
            },
            'details': {
                'title': 'Consignes',
                'description': 'Propres à cette mission, elles ne modifient pas la fiche de poste.',
                'tempWorker': 'Pour l\'intérimaire',
                'tempWorkerPlaceholder': 'Ex : L\'entrée des employés se trouve sur la porte à gauche de l\'enseigne',
                'jobbiz': 'Pour l\'équipe Jobbiz',
                'jobbizPlaceholder': 'Ex : profil autonome souhaité',
            },
            'invitation': {
                'title': 'Re-travailler avec un profil ?',
                'description': 'Sélectionnez les profils avec lesquels vous souhaitez travailler pour cette mission, les profils sélectionnés seront placés en priorité. Uniquement les profils disponibles sont affichés.',
                'searchPlaceholder': 'Nom ou prénom',
                'searchLabel': 'Rechercher un profil',
            },
            'confirmation': {
                'title': 'Tout est bon ?',
                'description': 'Relisez la mission avant de la créer. La fiche de poste ne se modifie pas ici.',
                'motif': 'Motif',
                'period': 'Période de la mission',
                'invitations': 'Intérimaires invités',
                'tempWorkerInstructions': 'Consignes intérimaire',
                'jobbizInstructions': 'Consignes Jobbiz',
                'template': 'Fiche de poste',
                'none': 'Aucun',
                'noneFeminine': 'Aucune',
                'edit': 'Modifier',
                'editMotif': 'Modifier le motif',
                'editPeriod': 'Modifier la période',
                'editInvitations': 'Modifier les invitations',
                'editTempWorkerInstructions': 'Modifier les consignes intérimaire',
                'editJobbizInstructions': 'Modifier les consignes Jobbiz',
            },
        },
        'missionTemplate': {
            'tools': {
                'provider': {
                    'company': 'Entreprise',
                    'temp_worker': 'Intérimaire',
                },
                'addLabel': 'Ajouter un matériel',
                'noOptions': 'Aucun matériel disponible',
                'providerSelectLabel': 'Fournisseur',
                'removeLabel': 'Retirer',
            },
            'pageTitle': {
                'create': 'Création d\'une fiche de poste',
                'edit': 'Modification d\'une fiche de poste',
            },
            'steps': {
                'activity': 'Secteur d\'activité',
                'riskyPosition': 'Poste à risque',
                'prerequis': 'Prérequis',
                'tasks': 'Tâches',
                'locationSalary': 'Lieu & rémunération',
                'confirmation': 'Confirmation',
            },
            'wizard': {
                'stepCount': 'Étape {current} sur {total}',
                'back': 'Retour',
                'next': 'Suivant',
                'save': 'Enregistrer la fiche',
                'saving': 'Enregistrement…',
                'backToStep': 'Revenir à cette étape',
                'leaveLabel': 'Quitter la création de fiche de poste',
                'leaveTooltip': 'Quitter',
                'leaveConfirm': 'Êtes-vous sûr de vouloir quitter la page ? Vos modifications ne seront pas enregistrées.',
                'notFound': 'Fiche de poste introuvable',
                'activityRequired': 'Veuillez sélectionner secteur et qualification',
                'nameRequired': 'Veuillez indiquer l\'intitulé de la fiche de poste',
                'nameTaken': 'Une fiche de poste porte déjà ce nom',
                'tasksRequired': 'Veuillez retenir au moins une tâche',
                'locationRequired': 'Veuillez renseigner une adresse',
                'salaryRequired': 'Veuillez renseigner un taux horaire',
                'contactRequired': 'Veuillez compléter les informations du responsable sur place',
                'created': 'Fiche de poste créée',
                'updated': 'Fiche de poste mise à jour',
                'createFailed': 'Création impossible',
                'updateFailed': 'Modification impossible',
            },
            'activity': {
                'sectorTitle': 'Secteur d\'activité',
                'sectorDescription': 'Dans quel secteur se situe le poste ?',
                'qualificationTitle': 'Qualification',
                'qualificationDescription': 'Quel est le métier exercé par l\'intérimaire ?',
                'qualificationPlaceholder': 'Choisir une qualification',
                'qualificationNoOptions': 'Sélectionnez le secteur d\'activité',
                'nameTitle': 'Intitulé de la fiche de poste',
                'nameDescription': 'Il commence par la qualification. Complétez après le tiret (ex : Nuit, Rayon frais).',
                'namePlaceholder': 'Ex : Préparatrice de commande - Nuit',
                'nameSuffixPlaceholder': 'Ex : Nuit',
                'nameTaken': 'Une fiche de poste porte déjà ce nom.',
            },
            'riskyPosition': {
                'title': 'Poste à risque',
                'description': 'Certains postes exigent une formation renforcée à la sécurité.',
                'question': 'Ce poste est-il à risque ?',
                'articleLink': 'Voir l\'article L. 4154-2 du Code du travail',
                'listLabel': 'Postes à risques concernés',
                'empty': 'Aucun poste à risque disponible',
                'loadError': 'Impossible de charger la liste des postes à risques. Veuillez réessayer plus tard.',
                'selectionRequired': 'Veuillez sélectionner au moins un poste à risque',
                'summaryNo': 'Non',
                'summaryYes': 'Oui',
            },
            'prerequis': {
                'title': 'Pré-requis',
                'description': 'Mentionnez les qualifications et matériels essentiels pour ces missions.',
                'tools': 'Matériel',
                'toolsPlaceholder': 'Ajouter du matériel',
                'licences': 'Permis',
                'licencesPlaceholder': 'Ajouter un permis',
                'languages': 'Langues',
                'languagesPlaceholder': 'Ajouter une langue',
                'dressCode': 'Tenue vestimentaire',
                'dressCodePlaceholder': 'Ex : pantalon noir, haut blanc uni, chaussures de sécurité',
                'dressCodeTooltip': 'Style vestimentaire attendu pendant la mission',
            },
            'tasks': {
                'title': 'Tâches du poste',
                'description': 'Cochez les tâches proposées ou ajoutez les vôtres.',
                'addPlaceholder': 'Ajouter une tâche (ex : accueil des livreurs)',
                'addButton': 'Ajouter',
                'countOne': '{count} tâche',
                'countMany': '{count} tâches',
                'selectedOfOne': 'sélectionnée sur {total}',
                'selectedOfMany': 'sélectionnées sur {total}',
                'addedByYou': 'Ajoutée par vous',
                'removeLabel': 'Retirer',
                'noProposal': 'Aucune tâche proposée pour cette qualification. Ajoutez celles de l\'intérimaire.',
                'duplicate': 'Cette tâche est déjà dans la liste.',
                'tooMany': 'Le nombre maximum de tâches est atteint.',
            },
            'locationSalary': {
                'locationTitle': 'Lieu de travail',
                'locationDescription': 'Où l\'intérimaire doit-il se présenter ?',
                'addressLabel': 'Adresse',
                'addressSearchLabel': 'Rechercher un lieu',
                'salaryTitle': 'Rémunération',
                'salaryDescription': 'Taux horaire brut, hors primes et majorations.',
                'salaryPlaceholder': 'Ex : 12,50',
                'salaryUnit': '€/h',
                'indexedTooltip': 'Quand la fiche est indexée au SMIC, le taux suit automatiquement la dernière valeur officielle.',
                'indexedLabel': 'Indexer au SMIC ({smic})',
                'belowMinimumWage': 'Le taux doit être au moins égal au SMIC ({smic} €/h).',
                'contactTitle': 'Responsable sur place',
                'contactDescription': 'La personne que l\'intérimaire contactera en arrivant.',
                'contactName': 'Nom et prénom',
                'contactPoste': 'Fonction',
                'contactPosteDefault': 'Responsable',
            },
            'confirmation': {
                'edit': 'Modifier',
                'title': 'Tout est bon ?',
                'description': 'Relisez la fiche avant de l\'enregistrer. Vous pourrez la modifier plus tard.',
            },
            'summary': {
                'none': 'Aucun',
                'noneFeminine': 'Aucune',
                'dressCodeMissing': 'Non renseignée',
                'tasksTwo': '{first} et {second}',
                'tasksManyOne': '{first}, {second} et {count} autre',
                'tasksMany': '{first}, {second} et {count} autres',
                'indexedToMinimumWage': 'indexé au SMIC',
            },
            'list': {
                'searchPlaceholder': 'Rechercher',
                'searchLabel': 'Rechercher une fiche de poste',
                'create': 'Créer',
                'loading': 'Chargement des fiches de poste…',
                'noResult': 'Aucune fiche de poste ne correspond à votre recherche.',
                'perHour': '/h',
                'belowMinimumWage': 'Sous le SMIC : mettez la fiche à jour avant de créer une mission.',
            },
            'preview': {
                'defaultTitle': 'Fiche de poste',
                'closeLabel': 'Fermer l\'aperçu',
                'closeTooltip': 'Fermer',
                'edit': 'Modifier',
                'delete': 'Supprimer',
                'duplicate': 'Dupliquer',
                'createMission': 'Créer une mission',
                'belowMinimumWage': 'Taux horaire inférieur au SMIC : modifiez la fiche pour pouvoir l\'utiliser.',
                'belowMinimumWageToast': 'Cette fiche est inférieure au SMIC, mettez-la à jour avant utilisation.',
                'fields': {
                    'name': 'Intitulé',
                    'activity': 'Secteur',
                    'qualification': 'Qualification',
                    'riskyPosition': 'Poste à risque',
                    'tools': 'Matériel',
                    'licences': 'Permis',
                    'languages': 'Langue',
                    'dressCode': 'Tenue vestimentaire',
                    'address': 'Adresse',
                    'salary': 'Taux horaire brut',
                    'contact': 'Responsable',
                    'tasks': 'Tâches',
                },
            },
            'duplicate': {
                'title': 'Dupliquer la fiche de poste',
                'description': 'La copie reprend tout le contenu de la fiche. Donnez-lui un nom.',
                'nameLabel': 'Nom de la nouvelle fiche',
                'suffixPlaceholder': 'Complément',
                'done': 'Fiche de poste dupliquée',
                'failed': 'Duplication impossible',
            },
            'modal': {
                'close': 'Fermer',
            },
        },
        'missionFiche': {
            'tasksTitle': 'Tâches du {title}',
            'tasksTitleElided': 'Tâches de l\'{title}',
        },
        'select': {
            'placeholder': 'Sélectionner…',
            'noOptions': 'Aucun résultat',
        },
        'perimeters': {
            'tab': 'Périmètres',
            'title': 'Périmètres',
            'description': 'Détermine les accès qu\'ont les manageurs pour gérer les missions, signatures des contrats et relevés d\'heures',
            'roles': {
                '200': 'Observateur',
                '205': 'Manageur',
                '210': 'Responsable',
                '215': 'Directeur',
                '220': 'Superviseur',
                '225': 'Administrateur',
            },
            'list': {
                'loading': 'Chargement des périmètres…',
                'loadError': 'Impossible de charger les périmètres.',
                'forbidden': 'Vous n\'avez pas les droits nécessaires pour gérer les périmètres.',
                'retry': 'Réessayer',
                'create': 'Créer',
                'edit': 'Modifier',
                'archive': 'Archiver',
                'members': {
                    'one': '{count} membre',
                    'many': '{count} membres',
                },
                'noMembers': 'Aucun membre rattaché',
            },
            'empty': {
                'title': 'Aucun périmètre pour l\'instant',
                'description': 'Sans périmètre, tous vos manageurs voient toutes les missions, contrats et relevés d\'heures. Créez des périmètres (un service, un site, une équipe...) pour limiter leurs accès.',
            },
            'form': {
                'createTitle': 'Créer un périmètre',
                'createDescription': 'Rattachez les membres qui géreront les missions de ce périmètre. Les membres sans périmètre continuent de tout voir.',
                'nameLabel': 'Nom du périmètre',
                'namePlaceholder': 'Ex. Cuisine, Site du Lamentin, Équipe de nuit',
                'membersLabel': 'Membres rattachés (optionnel)',
                'searchPlaceholder': 'Rechercher un membre',
                'noAssignableMember': 'Aucun membre à rattacher pour le moment.',
                'noSearchResult': 'Aucun membre ne correspond à votre recherche.',
                'create': 'Créer',
                'creating': 'Création…',
                'editTitle': 'Modifier «\u00A0{name}\u00A0»',
                'editDescription': 'Les changements s\'appliquent tout de suite aux accès des membres.',
                'save': 'Enregistrer',
                'saving': 'Enregistrement…',
            },
            'modal': {
                'cancel': 'Annuler',
            },
            'delete': {
                'title': 'Supprimer «\u00A0{name}\u00A0»\u00A0?',
                'description': 'Ce périmètre n\'est rattaché à aucune mission. Il sera supprimé définitivement.',
                'confirm': 'Supprimer',
                'deleting': 'Suppression…',
            },
            'archive': {
                'title': 'Archiver «\u00A0{name}\u00A0»\u00A0?',
                'transferTitle': 'Archiver «\u00A0{name}\u00A0»',
                'finishedMissions': {
                    'one': 'La mission terminée garde ce périmètre dans son historique.',
                    'many': 'Les {count} missions terminées gardent ce périmètre dans leur historique.',
                },
                'notProposed': 'Il ne sera plus proposé pour les nouvelles missions et vous pourrez le restaurer à tout moment.',
                'activeMissions': {
                    'one': '{count} mission en cours ou à venir',
                    'many': '{count} missions en cours ou à venir',
                },
                'transferIntro': '{missions} et {members} sont rattachés à ce périmètre. Les missions terminées le gardent dans leur historique.',
                'transferLabel': 'Transférer les missions et les membres vers',
                'noPerimeter': 'Aucun périmètre',
                'confirm': 'Archiver',
                'archiving': 'Archivage…',
                'usageError': 'Impossible de vérifier les accès des membres concernés.',
            },
            'restore': {
                'title': 'Restaurer «\u00A0{name}\u00A0»\u00A0?',
                'description': {
                    'one': 'Ce périmètre revient sans membre. Sa mission terminée lui sera de nouveau réservée\u00A0: tant que vous n\'y rattachez pas de membres, seuls les administrateurs, les directeurs et les membres sans périmètre la verront.',
                    'many': 'Ce périmètre revient sans membre. Ses {count} missions terminées lui seront de nouveau réservées\u00A0: tant que vous n\'y rattachez pas de membres, seuls les administrateurs, les directeurs et les membres sans périmètre les verront.',
                },
                'restoring': 'Restauration…',
            },
            'alert': {
                'membersAccess': {
                    'one': 'Le membre concerné aura accès à toutes les missions, contrats et relevés d\'heures.',
                    'many': 'Les {count} membres concernés auront accès à toutes les missions, contrats et relevés d\'heures.',
                },
            },
            'archived': {
                'heading': 'Archivés ({count})',
                'archivedOn': 'Archivé le {date}',
                'finishedMissions': {
                    'one': '{count} mission terminée',
                    'many': '{count} missions terminées',
                },
                'restore': 'Restaurer',
                'loadError': 'Impossible de charger les périmètres archivés.',
            },
            'toast': {
                'created': 'Périmètre créé',
                'updated': 'Périmètre modifié',
                'archived': 'Périmètre archivé',
                'deleted': 'Périmètre supprimé',
                'transferred': {
                    'one': '{count} mission transférée vers {name}',
                    'many': '{count} missions transférées vers {name}',
                },
                'archivedNoPerimeter': {
                    'one': 'Périmètre «\u00A0{name}\u00A0» archivé · {count} mission n\'a plus de périmètre',
                    'many': 'Périmètre «\u00A0{name}\u00A0» archivé · {count} missions n\'ont plus de périmètre',
                },
                'restored': 'Périmètre «\u00A0{name}\u00A0» restauré',
            },
            'errors': {
                'generic': 'Une erreur est survenue. Veuillez réessayer.',
                'nameRequired': 'Le nom du périmètre est obligatoire.',
                'nameTooLong': 'Ce nom est trop long.',
                'nameTaken': 'Un périmètre porte déjà ce nom (actif ou archivé).',
                'memberInvalid': 'Ce membre n\'est plus disponible : la liste a été actualisée.',
                'notFound': 'Ce périmètre n\'existe plus.',
                'archived': 'Ce périmètre est archivé : restaurez-le avant de le modifier.',
                'alreadyArchived': 'Ce périmètre est déjà archivé.',
                'notArchived': 'Ce périmètre n\'est plus archivé.',
                'inUse': 'Ce périmètre a déjà été rattaché à une mission : il ne peut plus être supprimé, seulement archivé.',
                'transferInvalid': 'Le périmètre choisi n\'est plus disponible pour le transfert.',
            },
            'missionStep': {
                'step': 'Détails',
                'title': 'Périmètre',
                'placeholder': 'Sélectionner',
                'noPerimeter': 'Aucun périmètre',
                'noPerimeterHint': 'Visible par tous les managers',
                'help': 'Seuls les managers de ce périmètre verront la mission, ses contrats et ses relevés d\'heures. Sans périmètre, elle est visible par tous.',
                'restrictedHelp': 'Vous ne pouvez rattacher une mission qu\'à vos périmètres : {names}.',
                'next': 'Suivant',
                'errors': {
                    'required': 'Choisissez un périmètre pour cette mission.',
                    'forbidden': 'Vous ne pouvez pas rattacher la mission à ce périmètre. Choisissez-en un autre.',
                    'archived': 'Ce périmètre vient d\'être archivé. Choisissez-en un autre.',
                    'notFound': 'Ce périmètre n\'existe plus. Choisissez-en un autre.',
                },
            },
            'missionDetail': {
                'label': 'Périmètre',
                'none': 'Aucun',
                'archived': '(archivé)',
                'edit': 'Modifier',
            },
            'listFilter': {
                'button': 'Périmètre',
                'count': '{count} périmètres',
                'noPerimeter': 'Aucun périmètre',
                'noPerimeterHint': 'Visible par tous les managers',
                'clear': 'Effacer',
                'column': 'Périmètre',
                'errors': {
                    'invalid': 'Ce filtre de périmètre n\'est pas valide : il a été effacé.',
                    'forbidden': 'Vous n\'avez plus accès à l\'un de ces périmètres : le filtre a été effacé.',
                    'notFound': 'L\'un de ces périmètres n\'existe plus : le filtre a été effacé.',
                },
            },
            'changeMission': {
                'title': 'Changer le périmètre',
                'recap': '{title} – n°{number}, {status}.',
                'recapWithoutNumber': '{title}, {status}.',
                'appliesNow': 'Le changement s\'applique tout de suite.',
                'status': {
                    'inProgress': 'en cours',
                    'upcoming': 'à venir',
                    'finished': 'terminée',
                },
                'label': 'Nouveau périmètre',
                'confirm': 'Changer',
                'changing': 'Changement…',
                'and': ' et ',
                'losingAccess': {
                    'one': '{names} n\'aura plus accès à cette mission, ni à ses contrats et relevés d\'heures.',
                    'many': '{names} n\'auront plus accès à cette mission, ni à ses contrats et relevés d\'heures.',
                },
                'optionsError': 'Impossible de charger les périmètres.',
                'previewError': 'Impossible de vérifier les accès des managers concernés.',
                'errors': {
                    'missionFinished': 'Cette mission est terminée : son périmètre ne peut plus être changé.',
                    'archived': 'Ce périmètre vient d\'être archivé. Choisissez-en un autre.',
                    'notFound': 'Ce périmètre n\'existe plus. Choisissez-en un autre.',
                    'forbidden': 'Vous ne pouvez pas rattacher la mission à ce périmètre. Choisissez-en un autre.',
                    'missionAccessDenied': 'Vous n\'avez plus accès à cette mission.',
                },
            },
        },
        'missionAccess': {
            'back': 'Retour',
            'mission': {
                'title': 'Vous n\'avez pas accès à cette mission',
                'description': 'Elle n\'est pas dans votre périmètre. Rapprochez-vous de votre administrateur.',
            },
            'document': {
                'title': 'Vous n\'avez pas accès à ce document',
                'description': 'Ce contrat ou ce relevé appartient à une mission ou une entreprise à laquelle vous n\'avez pas accès. Rapprochez-vous de votre administrateur.',
            },
        },
        'contract': {
            'documentUnavailable': 'Le document du contrat n\'est pas encore disponible. Réessayez plus tard ou contactez votre agence.',
        },
        'switchCompany': {
            'error': 'Le changement d\'entreprise a échoué. Veuillez réessayer.',
        },

    }
}